<section>
    <div class="wrapper">
    <article class="mrt-75 article">
      <div class="container header">
      <h2 class="header-name"><mat-icon class="custom-icon-button users">people</mat-icon>
       <span><a class="tag" routerLink="/cp/user-management">Users List</a></span><mat-icon class="chevron">chevron_right</mat-icon>
       <span>{{pageTitle}}</span></h2>
      </div>

      <div class="container-fluid box">
        <form [formGroup]="search" style="display: flex;">
          <div class="row user-search">
            <div class="d-flex gap-3">
              <mat-form-field appearance="outline" class="form-feild">
            <input 
              matInput
              formControlName="searchText"
              placeholder="Enter site name, account name or Potential ID"
              autocomplete="off"
              style="background-color: #F5F5F5 !important;"
              (keydown.enter)="$event.preventDefault()"
            />
        </mat-form-field>
        <button type="button" class="success-btn potential" (click)="performSearch()">Search</button>
      </div>
      <ul *ngIf="SiteNameSuggestions?.length> 0" class="suggestion-dropdown">
        <li *ngFor="let sitename of SiteNameSuggestions" class="dropdown-divider" (click)="onSuggestionClick(sitename,$event)">
          {{ sitename.siteName }}
        </li>
      </ul>
    </div> 
  </form>
</div>

    <div class="row table-user" >
        <ag-grid-angular *ngIf="showTable" class="ag-theme-balham grid" [rowData]="gridOptions.rowData" [columnDefs]="gridOptions.columnDefs"
            [defaultColDef]="gridOptions.defaultColDef" [paginationPageSize]="gridOptions.paginationPageSize"
            [pagination]="true" [enableRangeSelection]="true" [domLayout]="domLayout" (gridReady)="onGridReady($event)"
            [overlayNoRowsTemplate]="noRowsTemplate" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>
    
      <ng-template #openCamera let-c="close" let-d="dismiss">
        <h1 mat-dialog-title class="title">
            Camera Mapping   
            <button mat-icon-button class="close-icon" (click)="c('Close click'); closePopUp()">
              <mat-icon>close</mat-icon>
            </button>
        </h1>
       
        <mat-dialog-content class="custom-dialog-content">
          <div class="col-md-12">
            <label class="user-name">User Name</label>
            <input class="form-control" value="{{ userName }}" readonly />
          </div>
          <div class="col-md-12">
            <label class="camera-list">List of Cameras</label>
            <div *ngIf="camerasList.length > 0">
              <div>
                <mat-checkbox [(ngModel)]="selectAllChecked" (change)="selectAll()">
                  Select All
                </mat-checkbox>
              </div>
              <div *ngFor="let camera of camerasList;">
                <mat-checkbox name="options" value="{{ camera.id }}" [(ngModel)]="camera.checked" (change)="updateSelectAllChecked()">
                  {{ camera.name }}
                </mat-checkbox>
              </div>
            </div>
          </div>
        </mat-dialog-content>
        <div class="text-center">
            <button  mat-stroked-button color="basic" class="back" (click)="c('Close click'); closePopUp()">Cancel</button>
            <button class="select-btn" mat-raised-button (click)="saveCameraMapping()">Save</button>
          </div>
      </ng-template>
            
</article>
    </div>
    </section>
